import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useNavigate } from "react-router-dom";
import { getData } from "../../Webservice/Webservice";

const rubikfont = {
  fontFamily: "Rubik, sans-serif",
};

function WishList() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWishlist = async () => {
      const tokenValue = sessionStorage.getItem("token");
      const token = tokenValue ? `Bearer ${tokenValue}` : "";

      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await getData("wishlist/list", null, token);
        if (response && response.products) {
          setProducts(response.products);
        }
      } catch (error) {
        console.error("Error fetching wishlist:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchWishlist();
  }, []);

  if (loading) {
    return (
      <Box sx={{ minHeight: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container sx={{ py: { xs: 5, md: 8 }, ...rubikfont }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: { xs: 4, md: 6 },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: "28px", sm: "36px", md: "43.75px" },
            color: "#222",
            letterSpacing: "1.5px",
            fontWeight: 600,
            ...rubikfont,
          }}
        >
          WISHLIST
        </Typography>
      </Box>

      {/* Product Grid */}
      {products.length > 0 ? (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(2, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(4, 1fr)",
            },
            gap: { xs: 2, sm: 3, md: 4 },
          }}
        >
          {products.map((product, index) => (
            <Box
              onClick={() => navigate(`/product/${product._id}`)}
              key={product._id || index}
              className="product-card"
              sx={{
                bgcolor: "white",
                borderRadius: 2,
                overflow: "hidden",
                transition: "all 0.3s ease",
                cursor: "pointer",
                border: "1px solid #f0f0f0",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                  "& .product-image": {
                    transform: "scale(1.08)",
                  },
                  "& .action-icons": {
                    transform: "translateY(-50%) translateX(0)",
                    opacity: 1,
                  },
                },
              }}
            >
              {/* Product Image */}
              <Box
                sx={{
                  position: "relative",
                  paddingTop: "90%",
                  overflow: "hidden",
                  bgcolor: "#f8f8f8",
                }}
              >
                <img
                  src={product.product_images && product.product_images.length > 0 ? product.product_images[0] : "https://via.placeholder.com/300"}
                  alt={product.title}
                  className="product-image"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.4s ease",
                  }}
                />

                {/* Action Icons */}
                <Box
                  className="action-icons"
                  sx={{
                    position: "absolute",
                    right: 10,
                    top: "40%",
                    transform: "translateY(-50%) translateX(60px)",
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    opacity: 0,
                    transition: "all 0.4s ease",
                  }}
                >
                  {/* <IconButton
                    sx={{
                      bgcolor: "white",
                      color: "black",
                      width: { xs: 35, sm: 40, md: 45 },
                      height: { xs: 35, sm: 40, md: 45 },
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      "&:hover": {
                        bgcolor: "#222",
                        color: "white",
                        transform: "scale(1.1)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    <FavoriteIcon sx={{ fontSize: { xs: 16, sm: 18, md: 20 }, color: "red" }} />
                  </IconButton> */}

                  {/* <IconButton
                    sx={{
                      bgcolor: "white",
                      width: { xs: 35, sm: 40, md: 45 },
                      height: { xs: 35, sm: 40, md: 45 },
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      "&:hover": {
                        bgcolor: "#222",
                        color: "white",
                        transform: "scale(1.1)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    <ShoppingCartOutlinedIcon
                      sx={{ fontSize: { xs: 16, sm: 18, md: 20 } }}
                    />
                  </IconButton> */}

                  {/* <IconButton
                    onClick={() => navigate(`/product/${product._id}`)}
                    sx={{
                      bgcolor: "white",
                      width: { xs: 35, sm: 40, md: 45 },
                      height: { xs: 35, sm: 40, md: 45 },
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      "&:hover": {
                        bgcolor: "#222",
                        color: "white",
                        transform: "scale(1.1)",
                      },
                      transition: "all 0.3s ease",
                    }}
                  >
                    <VisibilityOutlinedIcon
                      sx={{ fontSize: { xs: 16, sm: 18, md: 20 } }}
                    />
                  </IconButton> */}
                </Box>
              </Box>

              {/* Product Details */}
              <Box sx={{ p: { xs: 1, sm: 1.5, md: 2 } }}>
                <Typography
                  sx={{
                    fontSize: { xs: "14px", sm: "16px", md: "18px" },
                    fontWeight: 500,
                    color: "#222",
                    // mb: 1.5,
                    minHeight: { xs: "36px", sm: "44px", md: "48px" },
                    ...rubikfont,
                  }}
                >
                  {product.title}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {/* b2b_sellingPrice */}
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", sm: "18px", md: "20px" },
                      fontWeight: 600,
                      color: "#222",
                      ...rubikfont,
                    }}
                  >
                    ₹{product.b2b_sellingPrice || product.sellingPrice || 0}
                  </Typography>
                  {/* b2c_mrp */}
                  {product.b2c_mrp && (
                    <Typography
                      sx={{
                        fontSize: { xs: "13px", sm: "14px", md: "16px" },
                        color: "red",
                        textDecoration: "line-through",
                        ...rubikfont,
                      }}
                    >
                      ₹{product.b2c_mrp}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <Box sx={{ textAlign: "center" }}>
          <img src="/img/nowishlist.png" alt="emplty" />
          <Typography variant="h6" sx={{ color: "#666", ...rubikfont }}>
            Your wishlist is empty.
          </Typography>
        </Box>
      )}
    </Container>
  );
}

export default WishList;
